import { render, staticRenderFns } from "./SidebarFieldsContainer.vue?vue&type=template&id=cc296b68&"
import script from "./SidebarFieldsContainer.vue?vue&type=script&lang=ts&"
export * from "./SidebarFieldsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarFieldsContainer.vue?vue&type=style&index=0&id=cc296b68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports